import React, { useEffect, useState } from "react";
import api from "../utils/api";
import ReferralView from "../components/profile/ReferralView";
import "./Referral.css";

const Referral = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await api.get("/api/auth/me");
        setUser(res.data.user || res.data);
      } catch (err) {
        // Optionally handle error
      }
    };
    fetchUser();
  }, []);

  return (
    <div className="referral-page-container">
      <ReferralView referralCode={user?.referralCode} s30Balance={user?.s30Balance} />

      <section className="referral-info-section">
        <h2>How Referral Bonus Works</h2>
        <ul>
          <li><strong>Referrer:</strong> When your friend signs up using your referral code and completes their first paid mock interview, you receive a <b>₹500 S30 balance</b> as a bonus.</li>
          <li><strong>Referred User:</strong> The person you refer also gets a <b>₹500 S30 balance</b> credited to their account after their first paid mock interview is completed.</li>
          <li>Both bonuses are credited automatically and can be used to book future mocks.</li>
          <li>There is no limit to how many friends you can refer!</li>
        </ul>
        <div className="referral-tips">
          <h3>Tips for Maximizing Your Referrals</h3>
          <ul>
            <li>Share your invite link on LinkedIn, WhatsApp, Twitter and with your friends preparing for interviews.</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default Referral;
